__turbopack_context__.v({
  "backgroundImage": "BlockHotspot-module-scss-module__YAvPGG__backgroundImage",
  "bounce-image": "BlockHotspot-module-scss-module__YAvPGG__bounce-image",
  "buttons": "BlockHotspot-module-scss-module__YAvPGG__buttons",
  "content": "BlockHotspot-module-scss-module__YAvPGG__content",
  "contentInner": "BlockHotspot-module-scss-module__YAvPGG__contentInner",
  "contentWrapper": "BlockHotspot-module-scss-module__YAvPGG__contentWrapper",
  "copy": "BlockHotspot-module-scss-module__YAvPGG__copy",
  "cta": "BlockHotspot-module-scss-module__YAvPGG__cta",
  "eyebrow": "BlockHotspot-module-scss-module__YAvPGG__eyebrow",
  "fade-in": "BlockHotspot-module-scss-module__YAvPGG__fade-in",
  "fade-up": "BlockHotspot-module-scss-module__YAvPGG__fade-up",
  "flushBottom": "BlockHotspot-module-scss-module__YAvPGG__flushBottom",
  "flushTop": "BlockHotspot-module-scss-module__YAvPGG__flushTop",
  "halfImage": "BlockHotspot-module-scss-module__YAvPGG__halfImage",
  "halfImageLayout": "BlockHotspot-module-scss-module__YAvPGG__halfImageLayout",
  "headline": "BlockHotspot-module-scss-module__YAvPGG__headline",
  "headline-block": "BlockHotspot-module-scss-module__YAvPGG__headline-block",
  "hide": "BlockHotspot-module-scss-module__YAvPGG__hide",
  "hotspotButton": "BlockHotspot-module-scss-module__YAvPGG__hotspotButton",
  "icon": "BlockHotspot-module-scss-module__YAvPGG__icon",
  "inner": "BlockHotspot-module-scss-module__YAvPGG__inner",
  "interactive": "BlockHotspot-module-scss-module__YAvPGG__interactive",
  "isInView": "BlockHotspot-module-scss-module__YAvPGG__isInView",
  "labels": "BlockHotspot-module-scss-module__YAvPGG__labels",
  "preHeadline": "BlockHotspot-module-scss-module__YAvPGG__preHeadline",
  "pulse": "BlockHotspot-module-scss-module__YAvPGG__pulse",
  "root": "BlockHotspot-module-scss-module__YAvPGG__root",
  "theme-cream-cheese": "BlockHotspot-module-scss-module__YAvPGG__theme-cream-cheese",
  "theme-holiday": "BlockHotspot-module-scss-module__YAvPGG__theme-holiday",
  "theme-shreds": "BlockHotspot-module-scss-module__YAvPGG__theme-shreds",
  "theme-slices": "BlockHotspot-module-scss-module__YAvPGG__theme-slices",
});
